export enum Filtros {
    Usuarios = 'filtros_usuarios',   
    Productos = 'filtros_productos',  
}
  
  